<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
                v-model=form
        >
            <template slot="contentForm">
                <avue-ueditor v-model="form.content" :upload="upload"></avue-ueditor>
            </template>
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  export default {
    mixins: [curd],
    data() {
      return {
        form: {},
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增同好会', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '名称',
              prop: 'title',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '名称不能为空', trigger: 'blur'
              }],
            },
            {
              label: '规则介绍',
              prop: 'content',
              type: 'textarea',
              overHidden: true,
              formslot: true,
              hide: true,
              rules: [{
                type: 'string', required: true, message: '规则不能为空', trigger: 'blur'
              }],
              span: 24
            },
            {
              label: '创建时间',
              prop: 'created_at',
              display: false,
              span: 24
            }
          ]
        }
      }
    }
  }
</script>
